import { render, staticRenderFns } from "./ReleaseEditor.vue?vue&type=template&id=6d4a9a00&scoped=true"
import script from "./ReleaseEditor.vue?vue&type=script&lang=js"
export * from "./ReleaseEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a9a00",
  null
  
)

export default component.exports